import React from 'react';
import Link from 'next/link';
import Icon from '@/app/components/Icon';
import { helpServicesData } from '../footerMenuList';
import TextSmall from '../../Typography/TextSmall';
import TextSpan from '../../Typography/TextSpan';

function FooterHelpServices() {
  return (
    <div className="min-w-[260px] w-full max-w-[13.54%]">
      {helpServicesData?.map((item) => (
        <div key={item?.id} className="border-b border-white pb-8">
          <TextSmall
            text={item?.title}
            className="text-white text-sm lg:text-sm font-bold mb-[8px]"
          />

          <ul className="space-y-2">
            {item?.menu?.map((menuItem) => (
              <li key={menuItem?.id}>
                <Link
                  prefetch={false}
                  arial-label="Go to help service menu item"
                  href={menuItem?.url}
                >
                  <TextSpan
                    text={menuItem?.name}
                    className="text-white text-sm lg:text-sm font-medium hover:underline"
                  />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div className="mt-8">
        <div className="space-y-[4px]">
          <div className="flex items-center gap-[4px]">
            <div className="min-w-[24px]">
              <Icon type="caller" />
            </div>
            <TextSmall
              text="Got Question? Reach us 24/7!"
              className="text-white text-sm lg:text-sm font-bold whitespace-nowrap"
            />
          </div>
          {helpServicesData[0].reachUsMenu.phones.map((phone, index) => (
            <TextSmall
              key={index}
              className="text-white text-sm lg:text-sm font-bold whitespace-nowrap"
            >
              <Link
                prefetch={false}
                aria-label="Go to phone number"
                href={phone.href}
                className="underline"
              >
                {phone.number}
              </Link>
              <TextSpan
                text={phone.label}
                className="inline-block text-white text-xs font-medium ml-4"
              />
            </TextSmall>
          ))}
        </div>
        <div className="mt-12">
          <div className="flex items-center gap-[4px] mb-4">
            <Icon type="message" />
            <TextSmall
              text={helpServicesData[0].reachUsMenu.email.label}
              className="text-white text-sm lg:text-sm font-bold"
            />
          </div>
          <Link
            prefetch={false}
            aria-label="Go to email us"
            href="mailto:info@singerbd.com"
          >
            <TextSmall
              text={helpServicesData[0].reachUsMenu.email.address}
              className="text-white text-sm lg:text-sm font-bold"
            />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default FooterHelpServices;
